import Spinner from "./Spinner";
import React from "react";

const LoadingScreen=({text=''})=> <div className="w-screen h-screen w-full bg-white  backdrop-blur backdrop-filter filter fixed z-100  top-0 flex justify-center flex-col items-center">
    <Spinner className="text-green-500 text-3xl md:text-3xl lg:text-6xl"/>
 {/*   <img alt="" className="w-36 h-auto  " src={Loading}/>*/}
    <span className="mt-2">{text}</span>
</div>
export default LoadingScreen;